import ProgressDot from 'components/shared/ProgressDot/ProgressDot'
import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './Progress.scss'

export const Progress = ({ progress = [], t }) => {
  const progressAmount = progress.reduce((acc, step) => {
    if (step.completed) {
      acc += 1
    }
    return acc
  }, 0)

  return (
    <>
      {progress && progress.length > 0 && (
        <div className={'c-progress'}>
          <span className={'c-progress__label'}>
            {t('general.progress.label')}
          </span>
          <span className={'c-progress__screenreader-label'}>
            {progressAmount > 0
              ? t('general.progress.some-progress', {
                  count: progressAmount,
                  total: progress.length,
                })
              : t('general.progress.no-progress')}
          </span>
          <ul className={'c-progress__items'} aria-hidden={true}>
            {progress.map((step, index) => {
              return (
                <li key={index} className={'c-progress__item'}>
                  <ProgressDot complete={step.completed} />
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </>
  )
}

Progress.propTypes = {
  progress: PropTypes.array,
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(Progress)
